import { connect } from 'react-redux';

import Footer from './footer';

const mapStateToProps = state => ({
  autoLogout: state.token.autoLogout,
  footer: state.app.pageData.footer,
  visitorInformation: state.app.pageData.visitorInformation
});

export default connect(mapStateToProps)(Footer);
